@if (hasRows()) {
  <div class="card mb-6 overflow-hidden p-0!" data-testid="comparison-section-aiCapabilities">
    <div
      class="border-themed flex flex-wrap items-baseline justify-between gap-2 border-b px-5 py-3"
    >
      <h2 class="m-0 text-sm font-bold">{{ 'hrTool.aiCapabilities' | transloco }}</h2>
      <span class="text-secondary text-xs">{{
        'hrTool.aiProfile.selfDeclaration' | transloco
      }}</span>
    </div>
    @for (row of rows(); track row.capability) {
      <div class="hr-compare-row" [style.--cols]="columnCount()" [attr.data-testid]="row.testId">
        <div class="hr-compare-row__label">
          <app-ai-capability-label [capability]="row.capability" />
        </div>
        @for (cell of row.cells; track cell.toolId) {
          <div
            class="hr-compare-row__cell flex-col gap-1 text-center"
            [attr.data-testid]="cell.testId"
          >
            <app-ai-capability-dots [level]="cell.level" />
            <app-ai-capability-level-label [level]="cell.level" />
            @if (cell.hasUseCases) {
              <span class="text-secondary text-xs">{{ cell.shownUseCasesText }}</span>
            }
            @if (cell.canToggle) {
              @if (cell.expanded) {
                <p-button
                  [label]="'hrTool.aiProfile.showFewerUseCases' | transloco"
                  [text]="true"
                  size="small"
                  (onClick)="toggleUseCases(cell.testId)"
                  [attr.data-testid]="cell.toggleTestId"
                />
              } @else {
                <p-button
                  [label]="cell.moreLabel"
                  [ariaLabel]="'hrTool.aiProfile.showAllUseCases' | transloco"
                  [text]="true"
                  size="small"
                  (onClick)="toggleUseCases(cell.testId)"
                  [attr.data-testid]="cell.toggleTestId"
                />
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
